import { Directive } from '@angular/core';

import { classes } from '../../../utils/src';

@Directive({
  selector: '[knxAlertAction]',
  host: {
    'data-slot': 'alert-action',
  },
})
export class KnxAlertAction {
  constructor() {
    // A normal grid item below the content rather than an absolutely positioned corner: floating it
    // meant the alert had to reserve a fixed gutter, and anything wider than that gutter — or any
    // title long enough to reach it — ended up underneath the action.
    classes(() => 'mt-2 justify-self-start group-has-[>ng-icon]/alert:col-start-2');
  }
}
